import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Unsubscribe = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handleUnsubscribe = async () => {
      if (!email) {
        setStatus('error');
        setMessage('Falta el email para procesar la baja.');
        return;
      }
      try {
        setStatus('loading');
        await axios.post(`${API}/exclusions`, { email, reason: 'Baja solicitada por enlace' });
        setStatus('success');
        setMessage('Tu baja se ha registrado correctamente.');
      } catch (error) {
        if (error?.response?.status === 400) {
          setStatus('exists');
          setMessage('Tu email ya estaba dado de baja.');
        } else {
          setStatus('error');
          setMessage('No hemos podido procesar la baja. Inténtalo más tarde.');
        }
      }
    };

    handleUnsubscribe();
  }, [email]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4" data-testid="unsubscribe-page">
      <Card className="w-full max-w-lg">
        <CardHeader>
          <CardTitle>Gestión de Baja</CardTitle>
          <CardDescription>Confirmación de tus preferencias de email</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div data-testid="unsubscribe-status">
            {status === 'loading' && 'Procesando tu solicitud...'}
            {status !== 'loading' && message}
          </div>
          <div className="flex flex-col sm:flex-row gap-2">
            <Button asChild variant="outline" data-testid="unsubscribe-back-home">
              <Link to="/">Volver a la web</Link>
            </Button>
            <Button asChild data-testid="unsubscribe-contact-button">
              <Link to="/">Contactar</Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Unsubscribe;